import { ColumnFiltersState, SortingState, VisibilityState } from '@tanstack/react-table'
import { atom } from 'jotai'
import { atomFamily } from 'jotai/utils'
import { getDefaultColumnVisibility } from '../utils/data.submodule.utils'
import { DataTabKey } from '../types'

/**
 * Per-tab UI state for DataLayerTable — search, sort, filters, and visible
 * columns — keyed by tab so it survives navigating away to a layer detail
 * page and back (DataLayerTable fully unmounts on that round trip).
 */

const getDefaultSorting = (tab: DataTabKey): SortingState =>
  tab === 'hazards' ? [{ id: 'name', desc: false }] : [{ id: 'category', desc: false }]

export const sortingAtomFamily = atomFamily((tab: DataTabKey) =>
  atom<SortingState>(getDefaultSorting(tab)),
)

export const globalFilterAtomFamily = atomFamily((_tab: DataTabKey) => atom(''))

export const columnFiltersAtomFamily = atomFamily((_tab: DataTabKey) =>
  atom<ColumnFiltersState>([]),
)

export const columnVisibilityAtomFamily = atomFamily((tab: DataTabKey) =>
  atom<VisibilityState>(getDefaultColumnVisibility(tab)),
)
